import { render, staticRenderFns } from "./device-warning.vue?vue&type=template&id=3413c9bc&"
import script from "./device-warning.vue?vue&type=script&lang=js&"
export * from "./device-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports